// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CarouselButtonGroup_arrow__1A_6W","wrapper":"CarouselButtonGroup_wrapper__sVW_D","buttonGroup":"CarouselButtonGroup_buttonGroup__2ixli"};